import React from 'react';
const BusinessTab = () => React.createElement("span", { className: "sirius-icon sirius-icon-business" });
BusinessTab.Enhance = () => React.createElement("span", { className: "sirius-icon sirius-icon-business sirius-icon-business-enhance" });
export default BusinessTab;
